const AboutSection = (props) => {
    return (
        <div className="tg23-about-wrapper">
            <p className="tg23-section-heading" data-value="ABOUT" onMouseOver={props.mouseHover}>ABOUT</p>
            <p className="tg23-about-para">
            In the ever-evolving world of technology, there's a place where innovation knows no bounds and inspiration flows freely. We're thrilled to unveil TECHNOGRAD, a groundbreaking event brought to you by DJS-NSDC. Set your calendars for two electrifying days, where we dive deep into the heart of all things tech. Get ready for an experience that blends knowledge, creativity, and camaraderie in the most exciting ways.
            </p>
        </div>
    );
}

export default AboutSection